import { FC, ReactNode } from 'react';
import { Card } from 'shared/ui/cards/modalCard';

interface OrderPersonInfoCardProps {
	children: ReactNode;
	buttons: ReactNode[];
	title?: string;
}

export const OrderPersonInfoCard: FC<OrderPersonInfoCardProps> = ({
	children,
	buttons,
	title = 'Контактная информация',
}) => {
	return (
		<Card
			headerContent={title}
			indentsCard={false}
			styles={{
				padding: '12px',
				header: { height: '24px', padding: '8px 16px' },
				cardVariant: 'secondary',
			}}
			buttons={buttons}
		>
			{children}
		</Card>
	);
};
